<template>
  <div>
    <div class="train">
      <div class="cate">
        <div class="cate_policeone">
          <div class="cate-all">文件类型 ：</div>
          <div class="subject" ref="getheight">
            <span
              v-for="(item, index) in policeClassification"
              :key="index"
              :class="{heightlight: cityIndex==index}"
              @click="btnTypeindex(index,item)"
            >{{ item.name }}</span>
          </div>
          <el-input
            size="large"
            placeholder="请输入搜索内容"
            @change="queryAll"
            v-model="listQuery.name"
            class="input-with-select"
            style="height:40px;width:287px;font-size:16px;border-radius:4px;flex-shrink: 0;"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryAll"
              style="background:#51565C;border-radius:0px;height:100%;color:white;font-size:16px;"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="box">
        <div class="hdFileBoxCon">
          <div class="fileLabelBox">
            <img src="@/assets/images/zsFile.png" alt="">
            <span>最新活动文件</span>
          </div>
          <div class="fgLine"></div>
          <div class="boxleft">
            <el-table :data="tableData" class="fileTableBox" height="623"  :header-cell-style="{'text-align':'center'}">
              <el-table-column prop="name" label="文件名称"  min-width="250" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span >{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="catename" label="类型" align="center" min-width="80"></el-table-column>
              <el-table-column prop="deptname" label="发布单位" min-width="120" align="center"></el-table-column>
              <el-table-column prop="downcount" label="下载次数" align="center" width="110"></el-table-column>
              <el-table-column prop="publishtime" label="上传时间" align="center" width="120">
                <template slot-scope="scope">
                  <span style="text-align: left;">{{ scope.row.publishtime?scope.row.publishtime.substring(0,10):'' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="operate" label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="dowloadFile(scope.row)">
                    <span style="font-size: 16px;">下载</span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="toolbar">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 30, 40]"
                :page-size="listQuery.limit"
                layout="total, prev, pager, next, jumper"
                :total="dataCount"
                style="margin: 10px"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPmiDic} from '@/api/teacher/teacherInfo';
import { getDownCount,getLoadDowload } from '@/api/message/index';
export default {
  components: {},
  data() {
    return {
      setHeight: 0,
      height: 0,
      photocom: [],
      baseData: [],
      newList: [
        { subType: null, name: '全部' },
        { subType: 0, name: '未开始' },
        { subType: 1, name: '进行中' },
        { subType: 2, name: '已结束' },
      ],
      newIndex: 0,
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      typeList: [{ name: '全部', id: 0 }],
      typeindex: 0,
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0,
      examTypeindex: 0, //高亮默认为全部
      listQuery: {
        cateId: null,
        name: '',
        page: 1,
        limit: 10,
        isShow: true,
      },
      listQuery2: {
        namespaceId: null,
      },
      tableData: [],
      dataCount: 0,
    };
  },
  created() {
    this.getPmiDictionary(75, this.policeClassification);
    this.getList();
  },
  methods: {
    queryAll() {
      this.listQuery.page = 1;
      this.getList();
    },
    btnTypeindex(index, item) {
      this.cityIndex = index;
      if (item.id == 0) {
        this.listQuery.cateId = null;
      } else {
        this.listQuery.cateId = item.id;
      }
      this.getList();
    },
    getPmiDictionary(index, arr) {
      this.listQuery2.namespaceId = index;
        getPmiDic(this.listQuery2)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
        })
        .catch(() => {});
    },
    //下载
    dowloadFile(row) {
      if (row.fileurl) {
        let urlArr = row.fileurl.split('.');
        let suffix = '.' + urlArr[urlArr.length-1];
        // window.open(row.fileurl);
        let a = document.createElement('a');
        a.setAttribute('download', row.name + suffix);
        a.setAttribute('target', '_blank');
        a.setAttribute('href', row.fileurl);
        a.click();

        getDownCount({ id: row.id }).then(() => {
          this.getList();
        });
      } else {
        this.$message.warning('未上传文件');
      }
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    getList() {
      getLoadDowload(this.listQuery).then((res) => {
        this.tableData = res.data;
        this.dataCount = res.count;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hdFileBoxCon{
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
}
.fileLabelBox{
  background-color: #fff;
  box-sizing: border-box;
  padding: 18px 0px 7px 38px;
  display: flex;
  align-items: center;
  border-radius: 4px 4px 0px 0px;

  &>img{
    height: 33px;
    width: 30px;
    margin-right: 23px;
  }

  &>span{
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000;
  }
}
.fgLine{
  background: linear-gradient(to right, #4192FF, #DB4144);
  height: 2px;
  width: 100%;
}

.fileTableBox{
  width: 100%;
  font-size: 16px;
  border-radius: 4px;
}
</style>

<style scoped>
.train {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 44px;
}

.box{
  width: 1200px;
  min-height: 500px;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 21px 13px 0px 13px;
  margin: 0 auto;
  margin-top: 14px;
}

.boxleft{
  width: 100%;
  min-height: 500px;
  box-sizing: border-box;
  padding: 0px 50px;
}

/* 头部搜索 */
.cate{
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 44px 29px 44px 35px;
  position: relative;
}
.cate_policeone{
  display: flex;
  align-items: center;
}

.cate-all {
  min-width: 70px;
  font-size: 14px;
  line-height: 21px;
  flex-shrink: 0;
  text-align: right;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  margin-left: 16px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 5px;
}

/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}

/* 头部搜索 */
/* 高亮 */
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}

.toolbar {
  margin-top: 25px;
  padding-bottom: 25px;
  text-align: center;
}
</style>